<template>
  <router-view name="setting" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "Setting",
};
</script>
